module.exports = __webpack_public_path__ + "static/media/gallery-icon.ea674f1f.png";